import { render, staticRenderFns } from "./b13.vue?vue&type=template&id=0663fe72&scoped=true"
import script from "./b13.vue?vue&type=script&lang=js"
export * from "./b13.vue?vue&type=script&lang=js"
import style0 from "./b13.vue?vue&type=style&index=0&id=0663fe72&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0663fe72",
  null
  
)

export default component.exports